import routes from './routes';
import { SetRoutes } from 'components';

const VisitCardPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default VisitCardPage;
